'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _common = require('../../../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DEFAULT_NUMBER_OF_RESULTS_TO_SHOW = 3,
    EmptySection = function EmptySection(props) {
  return _react2.default.createElement(
    'li',
    _extends({}, props, { className: 'disabled' }),
    _react2.default.createElement(
      'a',
      { role: 'button' },
      'No results found.'
    )
  );
},
    MenuHeader = function MenuHeader(props) {
  return _react2.default.createElement('li', _extends({}, props, { className: 'dropdown-header' }));
},
    ShowMoreButton = function ShowMoreButton(props) {
  return _react2.default.createElement(
    'li',
    _extends({}, props, { className: 'show-more' }),
    _react2.default.createElement(
      'a',
      { role: 'button' },
      _react2.default.createElement(_common.Icon, { type: 'angle-double-right' }),
      'Show more results'
    )
  );
};

ShowMoreButton.displayName = 'ShowMoreButton';
MenuHeader.displayName = 'MenuHeader';
EmptySection.displayName = 'EmptySection';

var SearchResultMenuSection = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(SearchResultMenuSection, _Component);

  function SearchResultMenuSection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchResultMenuSection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchResultMenuSection.__proto__ || Object.getPrototypeOf(SearchResultMenuSection)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showMore', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchResultMenuSection, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _isEqual3.default)(this.props.children, nextProps.children)) {
        this.showMore = false;
      }
    }
  }, {
    key: 'onShowMoreClick',
    value: function onShowMoreClick() {
      this.showMore = true;
    }
  }, {
    key: '_renderMenuItems',
    value: function _renderMenuItems() {
      if (this.props.children.length === 0) {
        return _react2.default.createElement(EmptySection, null);
      }
      if (!this.showMore) {
        return this.props.children.slice(0, DEFAULT_NUMBER_OF_RESULTS_TO_SHOW);
      }
      return this.props.children;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          title = _props.title;

      return _react2.default.createElement(
        'div',
        { className: 'dropdown-menu-section' },
        _react2.default.createElement(
          MenuHeader,
          null,
          _react2.default.createElement(
            'strong',
            null,
            title
          )
        ),
        this._renderMenuItems(),
        children.length > DEFAULT_NUMBER_OF_RESULTS_TO_SHOW && !this.showMore && _react2.default.createElement(ShowMoreButton, { onClick: this.onShowMoreClick })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return SearchResultMenuSection;
}(_react.Component), _class3.defaultProps = {
  children: []
}, _class3.propTypes = {
  children: _propTypes2.default.node,
  title: _propTypes2.default.string
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showMore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'onShowMoreClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onShowMoreClick'), _class2.prototype)), _class2)) || _class) || _class;

var _default = SearchResultMenuSection;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DEFAULT_NUMBER_OF_RESULTS_TO_SHOW, 'DEFAULT_NUMBER_OF_RESULTS_TO_SHOW', '/app/src/components/layout/search/results/SearchResultMenuSection.js');
  reactHotLoader.register(EmptySection, 'EmptySection', '/app/src/components/layout/search/results/SearchResultMenuSection.js');
  reactHotLoader.register(MenuHeader, 'MenuHeader', '/app/src/components/layout/search/results/SearchResultMenuSection.js');
  reactHotLoader.register(ShowMoreButton, 'ShowMoreButton', '/app/src/components/layout/search/results/SearchResultMenuSection.js');
  reactHotLoader.register(SearchResultMenuSection, 'SearchResultMenuSection', '/app/src/components/layout/search/results/SearchResultMenuSection.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/layout/search/results/SearchResultMenuSection.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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